function getColorBrightness(rgbColor) {
  var colorValues = rgbColor.match(/[\d\.]+/g).map(Number);
  return 0.2126 * (colorValues[0] / 255) + 0.7152 * (colorValues[1] / 255) + 0.0722 * (colorValues[2] / 255);
}

function isSimilarToBackground(color) {
  var backgroundColor = 'rgb(255, 255, 255)';

  var colorBrightness = getColorBrightness(color);
  var backgroundColorBrightness = getColorBrightness(backgroundColor);

  return (backgroundColorBrightness / colorBrightness) < 1.5;
}

var SwatchColors = (function() {
  function SwatchColors() {
    this.colors = {'1ffd9e753c8054cc61456ac7fac1ac89': 'rgb(1, 1, 0)','f33b6cef64ea236ab146fe3f6c40199c': 'rgb(1, 1, 0)','5834cd22968778514c6f4ba6c8146696': 'rgb(246, 207, 217)','dcb1423ca189bb3eea66234a4ef8d4f9': 'rgb(250, 250, 250)','554838a8451ac36cb977e719e9d6623c': 'rgb(250, 250, 250)','1244730250981555b85b921549264c09': 'rgb(250, 250, 250)','e07e81c20cf5935f5225765f0af81755': 'rgb(247, 242, 9)','2924e43197775d95e8ae0ca408c6f518': 'rgb(217, 216, 217)','c854a9398cad0d23e47cc833058b6a25': 'rgb(187, 184, 61)','ad5bd69476e5a48d4f0c6f734271e7a7': 'rgb(1, 1, 0)','0987d207117f659fe9e24ae8ccfbdb64': 'rgb(1, 1, 0)','4de54ae4aa802d04ea38d9309e67077b': 'rgb(217, 216, 217)','ae4041fc985b74c1f6c58fe344b0c45a': 'rgb(217, 216, 217)','272697c47e8af95b3d154525d80331d0': 'rgb(1, 1, 0)','9c413fbac47d8d1f9b09d7d4b425772d': 'rgb(1, 1, 0)','ae9c31665a220d3c600c5031e79afa70': 'rgb(250, 250, 250)','24b41da1a8e925472b976097c0ebf421': 'rgb(250, 250, 250)','a2d08914a21925fda7024a4b2c4483b4': 'rgb(187, 184, 61)','f9d40ebadf6dadc6d91c72caa63080a7': 'rgb(187, 184, 61)','fbd154788a8627839ec35cf3fa4adb2a': 'rgb(247, 242, 9)','cd9eaa906f517573c2257a3efe50127f': 'rgb(247, 242, 9)','94633298687aa964da807c1ca3d3d6d7': 'rgb(246, 207, 217)','4d239f518035ca287587bc926e3ddd7d': 'rgb(246, 207, 217)','ca50000a180a293de0b27acb67a695cb': 'rgb(105, 105, 105)','379a2975bbb70f6708c483ae558e78a9': 'rgb(105, 105, 105)','1fe48d2e4593eb4198d056f607b43d84': 'rgb(105, 105, 105)','08171b99e8a9b2daf96f4279bf1566b0': 'rgb(112, 87, 20)','ee342c4ea187496c68242eeab180e7e2': 'rgb(1, 1, 0)','494b50bcd400948f34890fc16dd2cd28': 'rgb(1, 1, 0)',};

    this.images = {};
  }

  function setSwatchColor(swatch) {
    var swatchId = swatch.getAttribute('swatch-id');

    if (Object.keys(this.colors).includes(swatchId)) {
      swatch.style.setProperty("--background-graphic", this.colors[swatchId]);

      if (isSimilarToBackground(this.colors[swatchId])) swatch.classList.add('is-similar-to-background');
      if (getColorBrightness(this.colors[swatchId]) > 0.5) {
        swatch.style.setProperty('--tick-color', '#000');
      } else {
        swatch.style.setProperty('--tick-color', '#fff');
      }
    }

    if (Object.keys(this.images).includes(swatchId)) {
      swatch.style.setProperty("--background-graphic", this.images[swatchId]);
      swatch.classList.add('is-image');
    }
  }
  SwatchColors.prototype.setSwatchColor = setSwatchColor;

  return SwatchColors;
}());

window.theme.swatches = new SwatchColors();

function VariantSwatch() {
  return Reflect.construct(HTMLElement, [], this.constructor);
}

VariantSwatch.prototype = Object.create(HTMLElement.prototype);
VariantSwatch.prototype.constructor = VariantSwatch;
Object.setPrototypeOf(VariantSwatch, HTMLElement);

VariantSwatch.prototype.connectedCallback = function() {
  window.theme.swatches.setSwatchColor(this);
};
customElements.define('variant-swatch', VariantSwatch);
